export enum BaseballStrikeoutAttribute {
  UncaughtThirdStrike = 1057,
}
